import React from "react";
import { Container, Row, Form, Button } from "react-bootstrap";

import moment from 'moment';

import questionOriginVariationsService from "presentation/services/question-origin-variations";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

import QuestionOriginVariationForm from 'presentation/pages/question-origin-variations/elements/form';

import { handleChange } from "presentation/utils/functions/generic";

class QuestionOriginVariationEdit extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      form: {},
      actionLoading: false,
      error: false,
      message: '',
    };
    this.loadData = this.loadData.bind(this);

  }

  async componentDidMount() {
    const { id } = this.props.match.params
    await this.loadData(id);
  }

  loadData = async (id) => {
    await questionOriginVariationsService.findById(id).then((result) => {
      
      if (result.startDate != null) {
        result.startDate = moment(result.startDate, 'YYYY-MM-DD').format("YYYY-MM-DD")
      }

      if (result.endDate != null) {
        result.endDate = moment(result.endDate, 'YYYY-MM-DD').format("YYYY-MM-DD")
      }


      this.setState({ form: result, loading: false });
    });
  }

  goTo = (destination) => {
    const { history } = this.props;

    history.push(destination);
  };

  handleSubmit = async () => {

    this.setState({ loading: true, actionLoading: true, error: '' });

    const {
      name,
      questionOriginId,
    } = this.state.form;

    if (!name) {
      this.setState({ loading: false, error: true, message: "Por favor, preencha um nome..." });
    } else {
      let postData = this.state.form;
      try {
        const response = await questionOriginVariationsService.update(postData);
        if (response.error == true) {
          this.setState({
            loading: false,
            actionLoading: false,
            error: true,
            message: response.message
          });
        } else {

          this.goTo(`/variacoes-origens-questoes/origem/${questionOriginId}`);
        }
      } catch (err) {
        this.setState({
          loading: false,
          actionLoading: false,
          error: true,
          message: err.message
        });
      }
    }
  };

  render() {
    let { location } = this.props;
    let { loading, error, message, actionLoading, form } = this.state;
    let { handleSubmit } = this;


    return (
      <div>
        {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
        {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
        {loading === false && (
          <Container>
            <Row>
              <QuestionOriginVariationForm
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                loading={loading}
                form={form}
                component={this}
              />
            </Row>
          </Container>
        )
        }
      </div>
    );
  };
}

export default QuestionOriginVariationEdit;
